import React from 'react';
import AliasFilter from '../../../../components/filter/AliasFilter';
import RegionFilter from '../../../../components/filter/RegionFilter';
import {
  Box,
  TablePagination,
  makeStyles,
  FormControl,
  useTheme
} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  filterHeader: {
    fontWeight: 'normal',
    fontSize: '1rem'
  },
  filterSection: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    width: '100%',
    backgroundColor: theme.palette.secondary.secondary,
    border: '1px solid #ced3d3',
    boxShadow: '0px 0px 1px 1px #cdd2d2'
  },
  filterSelect: {
    width: '100%',
    flexShrink: 1,
    height: 'fit-content',
    zIndex: 3
  },
  filterColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: 'fit-content',
    minWidth: '10rem',
    maxWidth: '15rem',
    margin: '5px'
  },
  pagination: {
    overflow: 'hidden',
    color: theme.palette.tertiary.secondary,
    backgroundColor: theme.palette.secondary.secondary,
    fontSize: '14px'
  },
  paginationMenuItem: {
    fontSize: '14px',
    color: theme.palette.tertiary.secondary,
    backgroundColor: theme.overrides.MuiPaper.root.backgroundColor,
    '&:hover': {
      backgroundColor: `${theme.palette.tertiary.secondary}40`
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: `${theme.palette.tertiary.secondary}40`
      }
    }
  },
  paginationMenu: {
    backgroundColor: theme.palette.secondary.secondary,
    '& .Mui-disabled': {
      color: theme.palette.action.disabled
    }
  },
  paginationContainer: {
    height: '3rem'
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: 'underline',
    '&hover': {
      color: theme.palette.text.primary
    }
  }
}));

function AbyssLeaderboardFilters(props) {
  const classes = useStyles();
  const theme = useTheme();

  const styles = {
    input: (provided, state) => ({
      ...provided,
      color: theme.palette.tertiary.secondary
    }),

    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#fff' : theme.palette.tertiary.secondary,
      backgroundColor: state.isFocused
        ? theme.palette.background.paperbg
        : theme.palette.secondary.secondary,
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      fontSize: '12px',
      fontFamily: 'Inter'
    }),

    control: (provided, state) => ({
      ...provided,
      fontSize: '12px',
      border: state.isSelected
        ? theme.palette.selected.active
        : '1px solid #ced3d3',
      backgroundColor: theme.palette.secondary.secondary
    }),

    singleValue: provided => ({
      ...provided,
      color: theme.palette.tertiary.secondary
    }),
    menu: (provided, state) => ({
      ...provided,
      color: 'black',
      border: state.isFocused
        ? theme.palette.selected.active
        : '1px solid #ced3d3',
      padding: '2px',
      backgroundColor: theme.palette.secondary.secondary,
      fontSize: '12px',
      fontFamily: 'Inter'
    }),

    menuPortal: provided => ({ ...provided, zIndex: 9999 })
  };
  return (
    <FormControl className={classes.filterSection}>
      <Box className={classes.filterColumn}>
        <AliasFilter
          placeholder="Search by name..."
          onChange={values => props.setFilter('competitor', values)}
          styles={styles}
        />
      </Box>
      <Box className={classes.filterColumn}>
        <RegionFilter
          onChange={values => props.setFilter('region', values)}
          placeholder="Search by region..."
          styles={styles}
        />
      </Box>
      <TablePagination
        className={classes.pagination}
        component="div"
        count={props.count}
        onChangePage={props.onChangePage}
        onChangeRowsPerPage={props.onChangeRowsPerPage}
        page={props.page}
        rowsPerPage={props.limit}
        rowsPerPageOptions={props.rowsPerPageoptions}
        labelRowsPerPage="Rows per page:"
        labelDisplayedRows={({ from, to, count, page }) =>
          `${from}-${to} of ${count}`
        }
      />
    </FormControl>
  );
}

AbyssLeaderboardFilters.propTypes = {
  setFilter: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.array,
  defaultValues: PropTypes.object
};

AbyssLeaderboardFilters.defaultProps = {
  rowsPerPageOptions: [10, 25, 50, 100],
  defaultValues: {}
};

export default AbyssLeaderboardFilters;
